import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'ai-consult-card',
  name: 'AI 咨询卡片',
  icon: '问',
  group: '国学组件',
  description: '展示国学 AI 咨询入口、模型卖点和引导按钮。',
  defaultProps: {
    title: '国学 AI 咨询',
    subtitle: '八字、节气、姓名、梦境与传统文化问答',
    buttonText: '立即咨询',
    link: '/pages/guoxue/ai'
  }
}
